import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const steps = [{
  number: '01',
  title: 'Discovery & Audit',
  description: 'We begin with a forensic analysis of your current financial standing, identifying inefficiencies and uncaptured opportunities.'
}, {
  number: '02',
  title: 'Strategic Blueprinting',
  description: 'Our team constructs a bespoke financial model tailored to your specific liquidity needs and long-term objectives.'
}, {
  number: '03',
  title: 'Implementation & Calibration',
  description: 'We execute the strategy with precision, constantly monitoring and recalibrating based on market feedback.'
}];
export function Process() {
  return <section className="py-24 bg-slate-900 text-white" data-id="element-42">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-44">
          <div data-id="element-45">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-6" data-id="element-46">
              The Powerquest Methodology
            </h2>
            <p className="text-lg text-blue-200 mb-8" data-id="element-47">
              Our proprietary approach removes emotion from the equation,
              relying instead on data-driven insights and rigorous
              stress-testing.
            </p>

            <div className="space-y-8" data-id="element-48">
              {steps.map((step, index) => <div key={index} className="flex gap-6" data-id="element-49">
                  <div className="flex-shrink-0" data-id="element-50">
                    <span className="flex h-12 w-12 items-center justify-center rounded-full border border-blue-700 bg-blue-800/50 text-lg font-bold text-blue-100" data-id="element-51">
                      {step.number}
                    </span>
                  </div>
                  <div data-id="element-52">
                    <h3 className="text-xl font-semibold text-white mb-2" data-id="element-53">
                      {step.title}
                    </h3>
                    <p className="text-blue-200 leading-relaxed" data-id="element-54">
                      {step.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-55">
            <div className="aspect-square rounded-2xl bg-gradient-to-br from-blue-800 to-slate-900 border border-blue-700/50 p-8 flex items-center justify-center" data-id="element-56">
              <div className="grid grid-cols-2 gap-4 w-full max-w-md" data-id="element-57">
                <div className="bg-blue-900/50 p-6 rounded-lg border border-blue-700/50 backdrop-blur-sm" data-id="element-58">
                  <div className="text-3xl font-bold text-white mb-1" data-id="element-59">24/7</div>
                  <div className="text-sm text-blue-300" data-id="element-60">
                    Portfolio Monitoring
                  </div>
                </div>
                <div className="bg-blue-900/50 p-6 rounded-lg border border-blue-700/50 backdrop-blur-sm" data-id="element-61">
                  <div className="text-3xl font-bold text-white mb-1" data-id="element-62">100%</div>
                  <div className="text-sm text-blue-300" data-id="element-63">
                    Fiduciary Standard
                  </div>
                </div>
                <div className="bg-blue-900/50 p-6 rounded-lg border border-blue-700/50 backdrop-blur-sm col-span-2" data-id="element-64">
                  <div className="flex items-center gap-2 mb-2" data-id="element-65">
                    <CheckCircle2 className="text-green-400 h-5 w-5" data-id="element-66" />
                    <span className="text-white font-medium" data-id="element-67">
                      Quarterly Rebalancing
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-68">
                    <CheckCircle2 className="text-green-400 h-5 w-5" data-id="element-69" />
                    <span className="text-white font-medium" data-id="element-70">
                      Tax-Loss Harvesting
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}